import { Link } from "react-router-dom";
import { Home as HomeIcon, ArrowRight } from "lucide-react";

const NotFound = () => (
  <div className="min-h-screen grid place-items-center bg-js-grey pt-[72px] px-5" data-testid="not-found-page">
    <div className="text-center max-w-lg">
      <p className="font-display font-extrabold text-js-blue text-7xl md:text-8xl tracking-tighter">404</p>
      <h1 className="font-display font-extrabold text-2xl md:text-3xl tracking-tight mt-4">Page not found</h1>
      <p className="text-js-charcoal/60 mt-4 leading-relaxed">
        Sorry, the page you're looking for doesn't exist or has moved. Let's get you back on track.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/" data-testid="notfound-home" className="group flex items-center gap-2 px-7 py-3.5 rounded-full bg-js-blue text-white font-semibold hover:bg-js-dark transition-colors duration-300">
          <HomeIcon size={18} /> Back to Home
        </Link>
        <Link to="/services" className="flex items-center gap-2 px-7 py-3.5 rounded-full bg-white border border-black/10 text-js-charcoal font-semibold hover:border-js-blue hover:text-js-blue transition-colors duration-300">
          View Services <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  </div>
);

export default NotFound;
